<template>
  <OrdersComponent />
</template>

<script>
// @ is an alias to /src
import OrdersComponent from "@/components/Account/Pages/Orders/Orders.vue";

export default {
  name: "Orders",
  components: {
    OrdersComponent
  }
};
</script>
